const PAGE_COLUMN = 'lg:max-w-[820px] lg:px-8';
const PAGE_COLUMN_FLUID = 'lg:max-w-[1200px] lg:px-8';
const PAGE_TOP_INSET = 'lg:pt-8';

export {PAGE_COLUMN, PAGE_COLUMN_FLUID, PAGE_TOP_INSET};
